<dx-html-editor height="600px" [(ngModel)]="value" (onValueChanged)="onValueChanged($event)" [placeholder]="placeholder" 
[(required)]="isRequired">
    <dxo-toolbar [multiline]="isMultiline">
      <dxi-item *ngFor="let item of dxiMap | keyvalue" name="{{item.key}}" [acceptedValues]="item.key==='size' ||item.key==='font' || item.key==='header'? item.value: ''">
      </dxi-item>
    </dxo-toolbar>
    <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
    <dxo-image-upload [tabs]="currentTab" fileUploadMode="base64">
    </dxo-image-upload>
</dx-html-editor>
  

